/** Human label for a ban's remaining time. null expiresAt = permanent. */
export function banRemainingLabel(expiresAt: string | null): string {
  if (!expiresAt) return 'Permanent'
  const ms = new Date(expiresAt).getTime() - Date.now()
  if (ms <= 0) return 'Expired'
  const totalMin = Math.ceil(ms / 60_000)
  const h = Math.floor(totalMin / 60)
  const m = totalMin % 60
  if (h > 0) return `${h} h ${m} min left`
  return `${m} min left`
}
